{
  "backButton": "Назад към {prevMenuButton}",
  "moreActions": "Повече действия",
  "unavailable": "Недостъпно, разгънете за подробности"
}
